import ComponentManager from '@/Management/ComponentManager';
// Kendo imports
import KendoDatePickerFactory from '@/Components/KendoDateTimePicker/Factories/KendoDatePickerFactory';
import KendoTimePickerFactory from '@/Components/KendoDateTimePicker/Factories/KendoTimePickerFactory';
import KendoDateAndTimePickerFactory from '@/Components/KendoDateTimePicker/Factories/KendoDateAndTimePickerFactory';
import KendoDatePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoDatePickerViewModel';
import KendoTimePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoTimePickerViewModel';
import KendoDateAndTimePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndTimePickerViewModel';
import KendoDatePicker from '@/Components/KendoDateTimePicker/Controls/KendoDatePicker';
import KendoTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoTimePicker';
import KendoDateAndTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoDateAndTimePicker';
//HTML imports
import DatePickerFactory from '@/Factories/ControlFactories/DatePickerFactory';
import TimePickerFactory from '@/Factories/ControlFactories/TimePickerFactory';
import DateAndTimePickerFactory from '@/Factories/ControlFactories/DateAndTimePickerFactory';
import DatePickerViewModel from '@/ViewModels/Controls/DatePickerViewModel';
import TimePickerViewModel from '@/ViewModels/Controls/TimePickerViewModel';
import DateAndTimePickerViewModel from '@/ViewModels/Controls/DateAndTimePickerViewModel';
import DatePicker from '@/Controls/DatePicker';
import TimePicker from '@/Controls/TimePicker';
import DateAndTimePicker from '@/Controls/DateAndTimePicker';
import type ControlFactory from "@/Factories/ControlFactory";
import type ControlViewModel from "@/ViewModels/ControlViewModel";
import type Control from "@/Controls/Control";

const extension = 'RADPresentation.HTMLClient.DefaultViewExtensions' as const;

ComponentManager.setConditionalFactory('DatePicker', () => KendoComponentHelper.useKendoDatePicker ? KendoDatePickerFactory as typeof ControlFactory : DatePickerFactory, extension);
ComponentManager.setConditionalViewModel('DatePickerViewModel', () => KendoComponentHelper.useKendoDatePicker ? KendoDatePickerViewModel as typeof ControlViewModel : DatePickerViewModel, extension);
ComponentManager.setConditionalControl('DatePicker', () => KendoComponentHelper.useKendoDatePicker ? KendoDatePicker as typeof Control : DatePicker, extension);

ComponentManager.setConditionalFactory('TimePicker', () => KendoComponentHelper.useKendoTimePicker ? KendoTimePickerFactory as typeof ControlFactory : TimePickerFactory, extension);
ComponentManager.setConditionalViewModel('TimePickerViewModel', () => KendoComponentHelper.useKendoTimePicker ? KendoTimePickerViewModel as typeof ControlViewModel : TimePickerViewModel, extension);
ComponentManager.setConditionalControl('TimePicker', () => KendoComponentHelper.useKendoTimePicker ? KendoTimePicker as typeof Control : TimePicker, extension);

ComponentManager.setConditionalFactory('DateAndTimePicker', () => KendoComponentHelper.useKendoDateAndTimePicker ? KendoDateAndTimePickerFactory as typeof ControlFactory : DateAndTimePickerFactory, extension);
ComponentManager.setConditionalViewModel('DateAndTimePickerViewModel', () => KendoComponentHelper.useKendoDateAndTimePicker ? KendoDateAndTimePickerViewModel as typeof ControlViewModel : DateAndTimePickerViewModel, extension);
ComponentManager.setConditionalControl('DateAndTimePicker', () => KendoComponentHelper.useKendoDateAndTimePicker ? KendoDateAndTimePicker as typeof Control : DateAndTimePicker, extension);

export default class KendoComponentHelper {
    public static useKendoDatePicker: boolean = false;
    public static useKendoTimePicker: boolean = false;
    public static useKendoDateAndTimePicker: boolean = false;

    public static switchToKendoDatePicker(): void {
        KendoComponentHelper.useKendoDatePicker = true;
    }

    public static switchToKendoTimePicker(): void {
        KendoComponentHelper.useKendoTimePicker = true;
    }

    public static switchToKendoDateAndTimePicker(): void {
        KendoComponentHelper.useKendoDateAndTimePicker = true;
    }

    public static switchAllToKendo(): void {
        KendoComponentHelper.switchToKendoDatePicker();
        KendoComponentHelper.switchToKendoTimePicker();
        KendoComponentHelper.switchToKendoDateAndTimePicker();
    }
}